import { render, staticRenderFns } from "./JapanMA.vue?vue&type=template&id=39d73e72"
import script from "./JapanMA.vue?vue&type=script&lang=js"
export * from "./JapanMA.vue?vue&type=script&lang=js"
import style0 from "./JapanMA.vue?vue&type=style&index=0&id=39d73e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports